import {routerPaths} from '../../../router/routerPaths'

const NotesTable = () => import(/* webpackChunkName: "group-notes" */ './components/NotesTable/NotesTable.vue')
const moduleKey = 'notes'

export const NotesRoutes = [
  {
    path: routerPaths.notes,
    component: NotesTable,
    meta: {
      breadcrumbs: {
        key: [
          'notes',
        ],
        items: {
          'notes': {
            name: 'menu_notes',
            link: routerPaths.notes,
          },
        },
      },

      moduleKey: moduleKey,
      pageTitle: 'menu_notes'
    },
  },
]
